import { createContext, useContext } from 'react';

import type { useCopilotChat } from './useCopilotChat';
import type { useCopilotThreads } from './useCopilotThreads';

export type CopilotChatHook = ReturnType<typeof useCopilotChat>;
export type CopilotThreadsHook = ReturnType<typeof useCopilotThreads>;

export interface SendCopilotTextParams {
  text: string;
  source: string;
}

export type SendCopilotTextFn = (params: SendCopilotTextParams) => void;

export interface CopilotSessionValue {
  userId: string;
  chat: CopilotChatHook;
  threads: CopilotThreadsHook;
  sendText: SendCopilotTextFn;
}

export const CopilotSessionContext = createContext<CopilotSessionValue | null>(null);

export function useCopilotSession(): CopilotSessionValue {
  const ctx = useContext(CopilotSessionContext);
  if (ctx === null) {
    throw new Error('useCopilotSession must be used within a CopilotSessionProvider');
  }
  return ctx;
}

export function useCopilotComposer(): { sendText: SendCopilotTextFn } {
  const ctx = useContext(CopilotSessionContext);
  if (ctx === null) {
    throw new Error('useCopilotComposer must be used within a CopilotSessionProvider');
  }
  return { sendText: ctx.sendText };
}
